import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-150c76d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "highlighted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.textFilter?.length > 2)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass({ ellipsis: _ctx.ellipsis })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notHighlightedText, (text, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, [
            _createElementVNode("span", null, _toDisplayString(text), 1),
            (index < _ctx.highlightedText.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.highlightedText[index]), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 2))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass({ ellipsis: _ctx.ellipsis })
      }, _toDisplayString(_ctx.label), 3))
}